module.exports = __webpack_public_path__ + "static/media/sns.920d095b.png";